<p-toast position="top-right" key="save"></p-toast>
<div class="fixed transform z-5" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-3 pb-3" id="htmldata" #htmldata>
    <div class="flex justify-content-between align-items-center title-bg title-case" style="margin-bottom: 5px;">
      <div class="conten">
        <div class="btn"><a>RAPIDi Trending</a></div>
      </div>
    </div>
<div class="grid justify-content-end">
    <div class="col-12 md:col-6 lg:col-2">
      <label for="FirstName"
        [ngStyle]="filterTypeErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}"><b>Filter
          Type</b></label>
      <p-dropdown [options]="selectedFacilityOptions" [(ngModel)]="selectedFilterType" placeholder="Select Filter Type"
        (onChange)="onChangeFilterType($event)" optionLabel="name" optionValue="value" class="mr-2"></p-dropdown>
    </div>
    <div *ngIf="filterTypeBool" class="col-12 md:col-6 lg:col-2">
      <label *ngIf="facilityQPSLbl == 1"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 1 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Facility</b></label>
      <label *ngIf="facilityQPSLbl == 2"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 2 ? {'color':'red','font-size':'15px'} : {'color':'black'}">System</b></label>
      <label *ngIf="facilityQPSLbl == 3"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 3 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Regional</b></label>
      <p-dropdown #dd [options]="SelectListFilter" [(ngModel)]="selectFacilityPIOptions"
        optionLabel="Text" [filter]="true" filterBy="Text" placeholder="-- Select --"
        optionValue="Value" class="mr-2"></p-dropdown>
    </div>
     <!-- Newly Added Spoke Side -->
     <div class="col-12 md:col-6 lg:col-2" *ngIf="spokeSiteBool == true">
      <label for="FirstName"><b>Spoke Site</b></label>
      <p-dropdown [options]="spokeSiteOpions" [(ngModel)]="spokeSite" optionLabel="Text" optionValue="Value"
        class="mr-2"></p-dropdown>
    </div>
    <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Time Frame:</b></label>
        <span class="p-input-icon-right w-full mt-1" id="frame_up">
          <p-dropdown [options]="timeFameList" (onChange)="onChangeTimeFrame($event)" [(ngModel)]="timeFrame"
            class="form-control" optionLabel="name" optionValue="value">
          </p-dropdown>
        </span>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="specificDatecolorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Date:</b></label>
        <p-calendar [(ngModel)]="txtSpecificDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showStartEndDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="textStrtColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Start
            Date:</b></label>
        <p-calendar [(ngModel)]="txtStartDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showStartEndDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="textEndColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">End
            Date:</b></label>
        <p-calendar [(ngModel)]="txtEndDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
  </div>
  <div class="md:col-12 px-0">
    <!-- Search Filters SelectEnd -->
    <div class="flex justify-content-end mb-2" id="search_chart_excel_btn">
      <!-- Search and Export button start -->
      <p-button label="Search" icon="pi pi-search" (click)="GetStrokeQualityMetricsData('click')"
        [loading]="SearchLoader == true" class="p-button-primary"></p-button>
    </div><!-- Search and Export button end -->
  </div>


  <div class="grid">
    <div class="accordian-pre col-12 md:col-12 lg:col-12 mt-2">

              <div id="circleDiagramTree" class="rcafish-responsive col-12 md:col-12 lg:col-12">
                <div  class="md:col-7 md:col-offset-2" id="mainRCADiagramFCRT"
                  >
                  <div class="grid relative align-items-center">

                    <div class="rental-manager-progress-bar-container">
                      <div class="squre-imge disableRCADiagram">
                        <div class="circle-imge circle-1">
                          <div id="RCAFishBoneJSTreeforActivation" class="SQM"> </div>
                          <img src="assets/images/svg-icons/activation-delay.png" width="65" height="65" />
                        </div>
                        <p><b>Activation</b><br/>
                          <b class="fb-total-count" *ngIf="activationCount">{{activationCount}}</b></p>
                      </div>
                      <div class="squre-imge disableRCADiagram">
                        <div class="circle-imge circle-2">
                          <div id="RCAFishBoneJSTreeforAssessment" class="SQM"> </div>
                          <img src="assets/images/svg-icons/assesment-start-time-delay.png" width="65" height="65" />
                        </div>
                        <p><b>Assessment Start</b><br/>
                          <b class="fb-total-count" *ngIf="assementStartCount">{{assementStartCount}}</b></p>
                      </div>
                      <div class="squre-imge disableRCADiagram">
                        <div class="circle-imge circle-3">
                          <div id="RCAFishBoneJSTreeforTD" class="SQM"> </div>
                          <img src="assets/images/svg-icons/thrombolytic-decision-delay.png" width="65" height="65" />
                        </div>
                        <p><b>Thrombolytic Decision</b><br/>
                          <b class="fb-total-count" *ngIf="thrombolyticDecisionCount">{{thrombolyticDecisionCount}}</b></p>
                      </div>
                      <div class="squre-imge disableRCADiagram">
                        <div class="circle-imge circle-4">
                          <div id="RCAFishBoneJSTreeforTA" class="SQM"> </div>
                          <img src="assets/images/svg-icons/thrombolytic-administration-delay.png" width="65" height="65" />
                        </div>
                        <p><b>Thrombolytic Administration </b><br/>
                          <b class="fb-total-count" *ngIf="thrombolyticAdministrationCount">{{thrombolyticAdministrationCount}}</b></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    </div>
  </div>
  </div>


    <!-- Tree Case Numbers diaglog -->
  <p-dialog header="Cases" [draggable]="false" [modal]="true" position="center" class="z-3"
  [(visible)]="showCaseListPopup" (onHide)="closeCaseListPopup()" [style]="{width: '30vw'}">

  <div class="case-list-wrapper p-3" style="min-height: 100px; max-height: 165px; overflow-y: auto;">
    <div class="flex flex-wrap gap-2 justify-start">
      <div *ngFor="let cas of caseList"
           class="flex items-center gap-2 cursor-pointer px-3 py-1 shadow-sm transition hover:shadow-md hover:scale-[1.03]"
           style="color: #633393; border: 1px solid #633393; border-radius: 5px;"
           (click)="Accesscase(cas.keysNumber)"
           pTooltip="View case"
           tooltipPosition="top"
           tooltipStyleClass="Email-tooltip">
        <span class="text-sm font-medium">{{ cas.caseNumber }}</span>
        <i class="pi pi-arrow-up-right text-xs" style="padding-top: 2px;"></i>
      </div>
    </div>
  </div>

  </p-dialog>